import styled from 'styled-components';

export const LogoImg = styled.img`
    margin-top: 0.8rem;
    height: 4rem;
`;
